import { Routes } from '@angular/router';

import { AuthGuardService } from './services/auth-guard.service';
import { orbitOpenFocusGuard } from './pages/orbit/orbit-open-focus.guard';
import { articlePageResolver } from './pages/article-page/article-page.resolver';
import { homePageSeoResolver } from './pages/home/home-page.resolver';
import { organisationPageResolver } from './pages/organisation-details/organisation-page.resolver';
import { dictionaryPageResolver } from './pages/blockchain-az/dictionary-page.resolver';



































































import { routeSeo } from './seo/seo-presets';

const homePageRoute = {
  loadComponent: () =>
    import('./pages/home/home-page-shell.component').then((m) => m.HomePageShellComponent),
  resolve: { homeSeo: homePageSeoResolver },
  data: routeSeo.home,
};

export const routes: Routes = [
  // {
  //   path: 'login',
  //   component: LoginContainerComponent
  // },
  // {
  //   path: 'creator',
  //   component: LoginContainerComponent,
  //   data: {
  //     mode: 'creator'
  //   }
  // },  
  // {
  //   path: 'vendor',
  //   component: LoginContainerComponent,
  //   data: {
  //     mode: 'vendor'
  //   }
  // },
  {
    path: 'auth/google-callback',
    loadComponent: () => import('./pages/google-callback/google-callback.component').then((m) => m.GoogleCallbackComponent),
    data: routeSeo.googleCallback,
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard-page/dashboard-page.component').then((m) => m.DashboardPageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.dashboard,
  },
  {
    path: 'my-chainmart',
    loadComponent: () => import('./pages/my-chainmart/my-chainmart-page.component').then((m) => m.MyChainmartPageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.myChainmart,
  },
  {
    path: 'my-chainmart/projects/:projectId',
    loadComponent: () =>
      import('./pages/my-chainmart/workbench-project-page.component').then((m) => m.WorkbenchProjectPageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.workbenchProject,
  },
  {
    path: 'marketplace',
    loadComponent: () => import('./pages/directory-list/directory-list.component').then((m) => m.DirectoryListComponent),
    data: routeSeo.marketplace,
  },
  {
    path: 'experts',
    loadComponent: () => import('./pages/expert-directory/expert-directory.component').then((m) => m.ExpertDirectoryComponent),
    data: routeSeo.experts,
  },
  {
    path: 'experts/:slug',
    loadComponent: () => import('./pages/expert-profile/expert-profile.component').then((m) => m.ExpertProfileComponent),
    data: routeSeo.expertProfile,
  },
  {
    path: 'directory',
    redirectTo: 'marketplace',
    pathMatch: 'full',
  },
  {
    path: 'register-organisation',
    loadComponent: () => import('./pages/register-organisation/register-organisation.component').then((m) => m.RegisterOrganisationComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.registerOrganisation,
  },
  {
    path: 'editorial-community',
    redirectTo: 'community',
    pathMatch: 'full',
  },
  {
    path: 'community',
    loadComponent: () => import('./pages/content-bounties/content-bounties.component').then((m) => m.ContentBountiesComponent),
    data: routeSeo.community,
  },
  {
    path: 'provider-hub',
    loadComponent: () => import('./pages/provider-hub/provider-hub-page.component').then((m) => m.ProviderHubPageComponent),
    data: routeSeo.providerHub,
  },
  /** Public store window; same UI as organisation management storefront (no org id in path). */
  {
    path: 'shop/:storeFrontId',
    loadComponent: () => import('./pages/organisation-storefront/organisation-storefront.component').then((m) => m.OrganisationStorefrontComponent),
    data: routeSeo.shop,
  },
  {
    path: 'organisation/:id/storefront/:storeFrontId',
    loadComponent: () => import('./pages/organisation-storefront/organisation-storefront.component').then((m) => m.OrganisationStorefrontComponent),
    data: routeSeo.organisationStorefront,
  },
  {
    path: 'organisation/edit/:id',
    loadComponent: () => import('./pages/organisation-edit-details/organisation-edit-details.component').then((m) => m.OrganisationEditDetailsComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.organisationEdit,
  },
  {
    path: 'organisation/:id/:slug',
    loadComponent: () =>
      import('./pages/organisation-details/organisation-page-shell.component').then(
        (m) => m.OrganisationPageShellComponent,
      ),
    resolve: { organisation: organisationPageResolver },
    data: { ...routeSeo.organisation, seoDynamic: true },
  },
  {
    path: 'organisation/:id',
    loadComponent: () =>
      import('./pages/organisation-details/organisation-page-shell.component').then(
        (m) => m.OrganisationPageShellComponent,
      ),
    resolve: { organisation: organisationPageResolver },
    data: { ...routeSeo.organisation, seoDynamic: true },
  },
  {
    path: 'admin/article-moderation-review-feedback/:articleId',
    loadComponent: () => import('./pages/admin/articles-moderation/article-moderation-review-feedback/articles-moderation-review-feedback.component').then((m) => m.ArticlesModerationReviewFeedbackComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/article-moderation-metadata/:articleId',
    loadComponent: () => import('./pages/admin/articles-moderation/article-moderation-metadata/articles-moderation-metadata.component').then((m) => m.ArticlesModerationMetadataComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'article-editor',
    loadComponent: () => import('./pages/article-editor-page/article-editor-page.component').then((m) => m.ArticleEditorPageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'article-editor/:articleId',
    loadComponent: () => import('./pages/article-editor-page/article-editor-page.component').then((m) => m.ArticleEditorPageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'referral/:code',
    loadComponent: () => import('./pages/referral-landing/referral-landing.component').then((m) => m.ReferralLandingComponent),
    data: routeSeo.referral,
  },
  {
    path: 'home',
    ...homePageRoute,
  },
  {
    path: 'education',
    redirectTo: 'discover',
    pathMatch: 'full',
  },
  {
    path: 'articles',
    redirectTo: 'discover',
    pathMatch: 'full',
  },
  {
    path: 'articles/:articleId',
    redirectTo: 'discover/:articleId',
  },
  {
    path: 'research',
    redirectTo: 'discover',
    pathMatch: 'full',
  },
  {
    path: 'research/:articleId',
    redirectTo: 'discover/:articleId',
  },
  {
    path: 'orbit',
    redirectTo: 'orbit-explorer/orbit',
    pathMatch: 'full',
  },
  {
    path: 'orbit/open',
    redirectTo: 'orbit-explorer/orbit',
  },
  {
    path: 'orbit-explorer/open',
    redirectTo: 'orbit-explorer/orbit',
  },
  {
    path: 'orbit-explorer/orbit',
    loadComponent: () => import('./pages/orbit/orbit-open-page.component').then((m) => m.OrbitOpenPageComponent),
    canActivate: [orbitOpenFocusGuard, AuthGuardService],
    data: routeSeo.orbitOpen,
  },
  {
    path: 'orbit-explorer',
    loadComponent: () => import('./pages/orbit/orbit-page.component').then((m) => m.OrbitPageComponent),
    data: routeSeo.orbit,
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile-page/profile-page.component').then((m) => m.ProfilePageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.profile,
  },
{
    path: 'profile/:id',
    loadComponent: () => import('./pages/profile-page/profile-page.component').then((m) => m.ProfilePageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.profile,
  },
  {
    path: 'creator-profile',
    loadComponent: () => import('./pages/creator-profile/creator-profile.component').then((m) => m.CreatorProfileComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'expert-profile',
    loadComponent: () => import('./pages/expert-profile/expert-profile.component').then((m) => m.ExpertProfileComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'register-creator',
    loadComponent: () => import('./pages/register-creator/register-creator.component').then((m) => m.RegisterCreatorComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.registerCreator,
  },
  {
    path: 'profile/edit/:id',
    redirectTo: 'settings',
    pathMatch: 'full',
  },
  {
    path: 'manage-articles',
    loadComponent: () => import('./pages/manage-articles/manage-articles.component').then((m) => m.ManageArticlesComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'bookmarks',
    loadComponent: () => import('./pages/bookmarks/bookmarks.component').then((m) => m.BookmarksComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'settings',
    loadComponent: () => import('./pages/settings-page/settings-page.component').then((m) => m.SettingsPageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'agent-keys',
    loadComponent: () => import('./pages/agent-keys/agent-keys.page').then((m) => m.AgentKeysPage),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'mcp/consent',
    loadComponent: () => import('./pages/mcp-consent/mcp-consent.page').then((m) => m.McpConsentPage),
    data: routeSeo.mcpConsent,
  },
  {
    // SiteUrl / PublicWebBaseUrl sometimes includes `/home`, which produced `/home/mcp/consent`.
    path: 'home/mcp/consent',
    redirectTo: '/mcp/consent',
    pathMatch: 'full',
  },
  {
    path: 'storefronts',
    loadComponent: () =>
      import('./pages/storefronts/storefronts-redirect.component').then(
        (m) => m.StorefrontsRedirectComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'checkout/:storeFrontItemId/confirmation/:purchaseId',
    loadComponent: () =>
      import('./pages/checkout/purchase-confirmation/purchase-confirmation.component').then(
        (m) => m.PurchaseConfirmationComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.purchaseConfirmation,
  },
  {
    path: 'checkout/:storeFrontItemId',
    loadComponent: () =>
      import('./pages/checkout/checkout.component').then((m) => m.CheckoutComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.checkout,
  },
  {
    path: 'item-viewer/:id',
    loadComponent: () => import('./pages/item-viewer/item-viewer.component').then((m) => m.ItemViewerPageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'storefront/:id',
    loadComponent: () => import('./pages/storefront/storefront.component').then((m) => m.StorefrontPageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'organisation-faq/:id',
    loadComponent: () => import('./pages/organisation-faq/organisation-faq.component').then((m) => m.OrganisationFaqPageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  {
    path: 'organisation-contract/:id',
    loadComponent: () => import('./pages/organisation-contract/organisation-contract.component').then((m) => m.OrganisationContractPageComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.appSignedIn,
  },
  /**
   * Discover (articles) routes: detail before list so `/discover/:id` deep links resolve.
   * `:articleId` is the document UUID; legacy int SourceArticleId still loads and redirects.
   * Legacy `/research`, `/articles` redirect above (Angular + Express 301 for SSR/SEO).
   */
  {
    path: 'discover/:articleId',
    loadComponent: () =>
      import('./pages/article-page/article-page-shell.component').then(
        (m) => m.ArticlePageShellComponent,
      ),
    resolve: { article: articlePageResolver },
    data: { ...routeSeo.article, seoDynamic: true },
  },
  {
    path: 'discover',
    loadComponent: () => import('./pages/articles-page/articles-page.component').then((m) => m.ArticlesPageComponent),
    data: routeSeo.articlesList,
  },
  {
    path: 'dictionary/:term',
    loadComponent: () =>
      import('./pages/blockchain-az/dictionary-page-shell.component').then(
        (m) => m.DictionaryPageShellComponent,
      ),
    resolve: { dictionary: dictionaryPageResolver },
    data: { ...routeSeo.dictionary, seoDynamic: true },
  },
  {
    path: 'dictionary',
    loadComponent: () =>
      import('./pages/blockchain-az/dictionary-page-shell.component').then(
        (m) => m.DictionaryPageShellComponent,
      ),
    resolve: { dictionary: dictionaryPageResolver },
    data: { ...routeSeo.dictionary, seoDynamic: true },
  },
  {
    path: 'filtered-articles',
    loadComponent: () => import('./pages/filtered-articles-page/filtered-articles-page.component').then((m) => m.FilteredArticlesPageComponent),
    data: routeSeo.articlesFiltered,
  },
  {
    path: 'legal/privacy-policy',
    loadComponent: () =>
      import('./pages/legal/legal-document-page.component').then((m) => m.LegalDocumentPageComponent),
    data: { ...routeSeo.legalPrivacy, kind: 'privacy-policy' },
  },
  {
    path: 'legal/terms-of-service',
    loadComponent: () =>
      import('./pages/legal/legal-document-page.component').then((m) => m.LegalDocumentPageComponent),
    data: { ...routeSeo.legalTerms, kind: 'terms-of-service' },
  },
  {
    path: 'legal/:kind',
    loadComponent: () =>
      import('./pages/legal/legal-document-page.component').then((m) => m.LegalDocumentPageComponent),
    data: routeSeo.legalPrivacy,
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin/admin/admin.component').then((m) => m.AdminComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/legal-documents',
    loadComponent: () =>
      import('./pages/admin/legal-documents/legal-documents-admin.component').then(
        (m) => m.LegalDocumentsAdminComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/system-settings',
    loadComponent: () => import('./pages/admin/system-settings/system-settings.component').then((m) => m.SystemSettingsComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/taxonomy-fingerprint',
    loadComponent: () =>
      import('./pages/admin/taxonomy-fingerprint/taxonomy-fingerprint-admin.component').then(
        (m) => m.TaxonomyFingerprintAdminComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/ai-usage',
    loadComponent: () =>
      import('./pages/admin/ai-usage-admin/ai-usage-admin.component').then((m) => m.AiUsageAdminComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/stripe-payment-test',
    loadComponent: () =>
      import('./pages/admin/stripe-payment-test/stripe-payment-test.component').then(
        (m) => m.StripePaymentTestComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/calendly-test',
    loadComponent: () =>
      import('./pages/admin/calendly-test/calendly-test.component').then((m) => m.CalendlyTestComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/amlbot-kyc-test',
    loadComponent: () =>
      import('./pages/admin/amlbot-kyc-test/amlbot-kyc-test.component').then(
        (m) => m.AmlBotKycTestComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/particle-wallet-test',
    loadComponent: () =>
      import('./pages/admin/particle-wallet-test/particle-wallet-test.component').then(
        (m) => m.ParticleWalletTestComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/nft-test',
    loadComponent: () =>
      import('./pages/admin/nft-test/nft-test.component').then((m) => m.NftTestComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/smart-contract-test',
    loadComponent: () =>
      import('./pages/admin/smart-contract-test/smart-contract-test.component').then(
        (m) => m.SmartContractTestComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/particle-nft-test',
    redirectTo: 'admin/nft-test',
    pathMatch: 'full',
  },
  {
    path: 'admin/search-index',
    loadComponent: () =>
      import('./pages/admin/search-index-admin/search-index-admin.component').then(
        (m) => m.SearchIndexAdminComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/message-hub',
    loadComponent: () =>
      import('./pages/admin/message-hub-manager/message-hub-manager.component').then(
        (m) => m.MessageHubManagerComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/listing-commerce',
    loadComponent: () =>
      import('./pages/admin/listing-commerce-admin/listing-commerce-admin.component').then(
        (m) => m.ListingCommerceAdminComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/checkout-countries',
    loadComponent: () =>
      import('./pages/admin/checkout-countries-admin/checkout-countries-admin.component').then(
        (m) => m.CheckoutCountriesAdminComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/email-manager',
    redirectTo: 'admin/message-hub?tab=messages',
    pathMatch: 'full',
  },
  {
    path: 'admin/moderation',
    loadComponent: () => import('./pages/admin/articles-moderation/articles-moderation.component').then((m) => m.ArticlesModerationComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/articles-published',
    loadComponent: () => import('./pages/admin/articled-published/articles-published.component').then((m) => m.ArticlesPublishedComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/sections',
    loadComponent: () => import('./pages/admin/sections/sections.component').then((m) => m.SectionsComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/content-definition',
    loadComponent: () =>
      import('./pages/admin/content-definition/content-definition.component').then(
        (m) => m.ContentDefinitionComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/content-definition/:structureId/test',
    loadComponent: () =>
      import('./pages/admin/content-definition/content-definition-test.component').then(
        (m) => m.ContentDefinitionTestComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/content-definition/:structureId',
    loadComponent: () =>
      import('./pages/admin/content-definition/content-definition-editor.component').then(
        (m) => m.ContentDefinitionEditorComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/content-components',
    loadComponent: () =>
      import('./pages/admin/content-components/content-components.component').then(
        (m) => m.ContentComponentsComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/content-components/new',
    loadComponent: () =>
      import('./pages/admin/content-components/content-component-editor.component').then(
        (m) => m.ContentComponentEditorComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/content-components/:componentId/edit',
    loadComponent: () =>
      import('./pages/admin/content-components/content-component-editor.component').then(
        (m) => m.ContentComponentEditorComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/content-components/:componentId',
    loadComponent: () =>
      import('./pages/admin/content-components/content-component-bench.component').then(
        (m) => m.ContentComponentBenchComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/articles-management',
    loadComponent: () => import('./pages/admin/articles-management/articles-management.component').then((m) => m.ArticlesManagementComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/articles-management/:articleId',
    loadComponent: () => import('./pages/admin/articles-management/article-authorship-modify/article-authorship-modify.component').then((m) => m.ArticleAuthorshipModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/users',
    loadComponent: () => import('./pages/admin/user-management/user-management.component').then((m) => m.UserManagementComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/users/edit/:userId',
    loadComponent: () => import('./pages/admin/user-modify/user-modify.component').then((m) => m.UserModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/users/new',
    loadComponent: () => import('./pages/admin/user-modify/user-modify.component').then((m) => m.UserModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/organisations',
    loadComponent: () => import('./pages/admin/organisation-management/organisation-management.component').then((m) => m.OrganisationManagementComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/organisations/edit/:organisationId',
    loadComponent: () => import('./pages/admin/organisation-modify/organisation-modify.component').then((m) => m.OrganisationModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/organisations/new',
    loadComponent: () => import('./pages/admin/organisation-modify/organisation-modify.component').then((m) => m.OrganisationModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'auth',
    loadComponent: () => import('@azure/msal-angular').then((m) => m.MsalRedirectComponent),
    data: routeSeo.auth,
  },
  {
    path: 'admin/editorial-review',
    loadComponent: () => import('./pages/admin/editorial-review/editorial-review.component').then((m) => m.EditorialReviewComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/home-guides',
    loadComponent: () => import('./pages/admin/home-how-to-guides/home-how-to-guides-management.component').then((m) => m.HomeHowToGuidesManagementComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/home-guides/edit/:guideId',
    loadComponent: () => import('./pages/admin/home-how-to-guides/home-how-to-guide-modify.component').then((m) => m.HomeHowToGuideModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/home-guides/new',
    loadComponent: () => import('./pages/admin/home-how-to-guides/home-how-to-guide-modify.component').then((m) => m.HomeHowToGuideModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/carousels',
    loadComponent: () => import('./pages/admin/carousel-management/carousel-management.component').then((m) => m.CarouselManagementComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/carousels/edit/:carouselId',
    loadComponent: () => import('./pages/admin/carousel-modify/carousel-modify.component').then((m) => m.CarouselModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/carousels/new',
    loadComponent: () => import('./pages/admin/carousel-modify/carousel-modify.component').then((m) => m.CarouselModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/templates',
    loadComponent: () => import('./pages/admin/template-management/template-management.component').then((m) => m.TemplateManagementComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/documents/view/:documentId',
    loadComponent: () => import('./pages/admin/document-view/document-view.component').then((m) => m.DocumentViewComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/documents',
    loadComponent: () => import('./pages/admin/document-browser/document-browser.component').then((m) => m.DocumentBrowserComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/dictionary/new',
    loadComponent: () => import('./pages/admin/dictionary-term-modify/dictionary-term-modify.component').then((m) => m.DictionaryTermModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/dictionary/edit/:dictionaryTermId',
    loadComponent: () => import('./pages/admin/dictionary-term-modify/dictionary-term-modify.component').then((m) => m.DictionaryTermModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/dictionary',
    loadComponent: () => import('./pages/admin/dictionary-hub/dictionary-hub.component').then((m) => m.DictionaryHubComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/creator-applications',
    loadComponent: () => import('./pages/admin/creator-applications/creator-applications.component').then((m) => m.CreatorApplicationsComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/tags',
    loadComponent: () => import('./pages/admin/tag-manager/tag-manager.component').then((m) => m.TagManagerComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/templates/edit/:templateId',
    loadComponent: () => import('./pages/admin/template-modify/template-modify.component').then((m) => m.TemplateModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/templates/new',
    loadComponent: () => import('./pages/admin/template-modify/template-modify.component').then((m) => m.TemplateModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/templates/view/:templateId',
    loadComponent: () => import('./pages/admin/template-modify/template-modify.component').then((m) => m.TemplateModifyComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/editor-playground',
    loadComponent: () => import('./pages/admin/editor-playground/editor-playground.component').then((m) => m.EditorPlaygroundComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/orbit-playground',
    loadComponent: () => import('./pages/admin/orbit-playground/orbit-playground.component').then((m) => m.OrbitPlaygroundComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/page-sections-playground',
    loadComponent: () => import('./pages/admin/page-sections-playground/page-sections-playground.component').then((m) => m.PageSectionsPlaygroundComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/report-sections-playground',
    loadComponent: () => import('./pages/admin/report-sections-playground/report-sections-playground.component').then((m) => m.ReportSectionsPlaygroundComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/taxonomy-explorer',
    loadComponent: () => import('./pages/admin/taxonomy-explorer/taxonomy-explorer.component').then((m) => m.TaxonomyExplorerComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/schema-explorer',
    redirectTo: 'admin/taxonomy-explorer',
    pathMatch: 'full',
  },
  {
    path: 'admin/pyramid-explorer',
    redirectTo: 'admin/taxonomy-explorer',
    pathMatch: 'full',
  },
  {
    path: 'admin/attribute-catalog',
    loadComponent: () => import('./pages/admin/attribute-catalog-admin/attribute-catalog-admin.component').then((m) => m.AttributeCatalogAdminComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/attribute-values',
    loadComponent: () => import('./pages/admin/attribute-values-admin/attribute-values-admin.component').then((m) => m.AttributeValuesAdminComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/orbit-releases',
    loadComponent: () =>
      import('./pages/admin/orbit-releases-admin/orbit-releases-admin.component').then(
        (m) => m.OrbitReleasesAdminComponent,
      ),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/business-case-programmes',
    loadComponent: () => import('./pages/admin/business-case-programmes-admin/business-case-programmes-admin.component').then((m) => m.BusinessCaseProgrammesAdminComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/business-case-programmes/:programmeId',
    loadComponent: () => import('./pages/admin/business-case-programmes-admin/business-case-programme-detail.component').then((m) => m.BusinessCaseProgrammeDetailComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: 'admin/buyer-journeys',
    redirectTo: 'admin/business-case-programmes',
    pathMatch: 'full',
  },
  {
    path: 'admin/buyer-journeys/:programmeId',
    redirectTo: 'admin/business-case-programmes/:programmeId',
  },
  {
    path: 'admin/rebac-inspector',
    loadComponent: () => import('./pages/admin/rebac-inspector/rebac-inspector.component').then((m) => m.RebacInspectorComponent),
    canActivate: [AuthGuardService],
    data: routeSeo.admin,
  },
  {
    path: '',
    pathMatch: 'full',
    ...homePageRoute,
  },
  {
    path: '**',
    redirectTo: 'home',
  }
];